import React from 'react';
import PropTypes from 'prop-types';

import SwipeableDrawer from '@mui/material/SwipeableDrawer';
import MenuOpenOutlinedIcon from '@mui/icons-material/MenuOpenOutlined';
import {IconButton} from '@mui/material';

import {StyledDrawer} from 'components/styled';
import {SIDE_BAR_COMPONENT_TEST_ID} from 'testidConstants';

//REDUX
import {connect} from 'react-redux';
import {setIsMenuDrawerOpen, isMenuDrawerOpenSelector} from 'redux/slices/appHeaderSlice';

const ConditionalWrapper = ({isMobile, isDrawerOpen, children, setIsDrawerOpen}) => {
  return isMobile ? (
    <SwipeableDrawer
      PaperProps={{
        sx: {
          width: '90%'
        }
      }}
      open={isDrawerOpen}
      onClose={() => setIsDrawerOpen(false)}
      onOpen={() => setIsDrawerOpen(true)}
    >
      <IconButton onClick={() => setIsDrawerOpen(false)} style={{justifyContent: 'flex-start', width: '36px'}}>
        <MenuOpenOutlinedIcon fontSize="large" color='primary' />
      </IconButton>
      {children}
    </SwipeableDrawer>
  ) : (
    <StyledDrawer variant="permanent" style={{width: '100%'}} data-testid={SIDE_BAR_COMPONENT_TEST_ID}>
      {children}
    </StyledDrawer>
  );
};

ConditionalWrapper.propTypes = {
  isMobile: PropTypes.bool,
  isDrawerOpen: PropTypes.bool,
  children: PropTypes.array,
  setIsDrawerOpen: PropTypes.func
};

const mapDispatchToProps = (dispatch) => {
  return {
    setIsDrawerOpen: (isOpen) => dispatch(setIsMenuDrawerOpen(isOpen))
  };
};
const mapStateToProps = (state) => ({
  isDrawerOpen: isMenuDrawerOpenSelector(state)
});

export default connect(mapStateToProps, mapDispatchToProps)(ConditionalWrapper);
